const tableCustomStyles = (isSelectableRows, boderSelection, gridBorders = false) => {
    const gridBorderStyle = gridBorders
        ? {
              borderRight: '1px solid var(--cardBorder, #dee2e6)',
              borderLeft: '1px solid var(--cardBorder, #dee2e6)',
              borderBottom: '1px solid var(--cardBorder, #dee2e6)',
          }
        : {}
    const gridHeaderBorderStyle = gridBorders
        ? { ...gridBorderStyle, borderTop: '1px solid var(--cardBorder, #dee2e6)' }
        : {}

    return ({
    expanderCell: {
        style: {
            backgroundColor: 'var(--layout)',
        },
    },
    expanderButton: {
        style: {
            color: 'var(--textWhiteColor)',
        },
    },
    noData: {
        style: {
            backgroundColor: 'var(--layout)',
            color: 'var(--textWhiteColor)',
        },
    },
    progress: {
        style: {
            backgroundColor: 'var(--layout)',
        },
    },
    headCells: {
        style: {
            ...gridHeaderBorderStyle,
            ...(boderSelection && {
                '&:nth-child(5),&:nth-child(6)': {
                    borderLeft: '1px solid var(--tableRowHoverColor)',
                    borderRight: '1px solid var(--tableRowHoverColor)',
                    borderCollapse: 'collapse',
                    padding: 0,
                },
            }),
            fontSize: '16px',
            fontWeight: '500',
            backgroundColor: 'var(--tableBg)',
            color: 'var(--textWhiteColor)',
        },
    },
    cells: {
        style: {
            ...gridBorderStyle,
            ...(isSelectableRows
                ? {
                      fontSize: '16px',
                      color: 'var(--tableCellColor)',
                      '&:nth-child(1)': {
                          backgroundColor: 'var(--layout)',
                      },
                      div: {
                          whiteSpace: 'unset !important',
                      },
                      table: {
                          pointerEvents: 'none',
                      },
                  }
                : {
                      fontSize: '16px',
                      color: 'var(--tableCellColor)',
                      div: {
                          whiteSpace: 'unset !important',
                      },
                      table: {
                          pointerEvents: 'none',
                      },
                  }),
        },
    },
    rows: {
        style: {
            '&:nth-child(even)': {
                backgroundColor: 'var(--tableEvenRowColor)',
            },
            backgroundColor: 'var(--tableOddRowColor)',
        },
        highlightOnHoverStyle: {
            backgroundColor: 'var(--tableRowHoverColor)',
            outline: 'none',
            borderBottom: '1px solid var( --tableRowHoverColor)',
        },
    },
})
}

export default tableCustomStyles
